import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useRoleTheme } from '../hooks/useRoleTheme';
import { UiSettingsProvider } from '../contexts/UiSettingsContext';
import { VariantProvider } from '../contexts/VariantContext';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const InnerThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { theme } = useRoleTheme();
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => (
  <UiSettingsProvider>
    <VariantProvider>
      <InnerThemeProvider>{children}</InnerThemeProvider>
    </VariantProvider>
  </UiSettingsProvider>
);